import { UserRound } from '@orgus/ui/icons';
import type { SettingsSection } from '../registry.ts';
import { LaunchAccountsView } from '../../launch-accounts/AccountsView.tsx';

/** The accounts each agent's sessions run on (Claude Code, Codex, Gemini CLI), chosen per session or per project (ADR 0071, ADR 0078). The id stays 'accounts', so links keep working. */
const section: SettingsSection = {
  id: 'accounts',
  title: 'Agent accounts',
  description: 'The sign-ins, API keys and cloud providers Claude Code, Codex and Gemini sessions run on.',
  order: 15,
  group: 'agents',
  keywords: ['accounts', 'agent accounts', 'claude accounts', 'subscription', 'claude max', 'organisation', 'api key', 'foundry', 'azure', 'bedrock', 'vertex', 'sign in', 'login', 'config dir', 'codex', 'chatgpt', 'openai', 'codex home', 'gemini', 'google', 'gemini api key', 'gemini cli home'],
  icon: UserRound,
  Component: LaunchAccountsView,
};
export default section;
